








export default {
  name: 'AssetSearchHelp',
};
